import { message } from "antd";
import { CreateCalculationSetting } from "../../api/CreateCalculationSetting";
import { useAPIResponse } from "../global/useApiResponse";

export const useCreateCalculationSetting = async (payload: any) => {
  await message.loading("Creating Calculation Setting..", 2);
  const response = await CreateCalculationSetting(payload);

  return useAPIResponse(response);
};
